<data-table *ngIf="!app" [plainData]="apps" [columns]="appColumns" [newHeader]="true" [noCard]="true"
            (detail)="selectApp($event)" title="Applikation auswählen"></data-table>

<data-table *ngIf="!!app" [plainData]="entries" [columns]="entryColumns" [newHeader]="true" [noCard]="true"
            (detail)="selectEntry($event)" title="Eintrag auswählen" noDataMessage="Dieser Eintrag hat keine weitere Subanvigation!"></data-table>

<div class="selected-content" *ngIf="app">
  <span>{{app?.translations?.[0]?.appTitle}}<mat-icon (click)="reset()">delete</mat-icon></span>
  <span *ngFor="let entry of entryChain; let i = index"> > {{entry.title}}<mat-icon (click)="reset(i)">delete</mat-icon></span>
</div>

<div class="buttons">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}</button>
  <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.add' | translate }}</button>
</div>
